import { useNavigate, useParams } from '@tanstack/react-router';
import { ExercisePage } from '@/routes/_app.learn.$subject.$level.$chapter.$exercise';

export function TutorExerciseTestPage() {
  const { exerciseId } = useParams({ strict: false }) as { exerciseId: string };
  const navigate = useNavigate();

  return (
    <ExercisePage
      previewMode
      previewExerciseId={exerciseId}
      onExitPreview={() => navigate({ to: '/tutor/exercises/$exerciseId', params: { exerciseId } })}
    />
  );
}
